export const backgroundHeight = 187;
export const backgroundHeightDesktop = `min(15vh, ${backgroundHeight}px)`;

export const productImageHeight = 244;
export const productImageHeightDesktop = 'min(32vh, 344px)';

export const productImageTrayOffset = 125;
export const productImageTrayOffsetDesktop = 'min(15vh, 125px)';

export const productImageContainerHeight =
  backgroundHeight + productImageHeight - productImageTrayOffset;
export const productImageContainerHeightDesktop = `calc(${backgroundHeightDesktop} + ${productImageHeightDesktop} - ${productImageTrayOffsetDesktop})`;
